import axios from 'axios'
import qs from 'qs'
import { lib } from '../assets/js/lib'
import store from './../vuex/store'
import router from "@/router";
import { MessageBox } from 'element-ui';
import customerService from '@/assets/img/common/customerService.png';
import whatApp from '@/assets/img/common/whatApp.png';
const instance = axios.create({
  baseURL: 'https://api.zhixuejun.com',
  //baseURL: 'https://testapi.zhixuejun.com',
  withCredentials: true, // 是否携带cookie
  timeout: 70000,
  // timeout: 10,
  headers: {
    //'Content-Type': 'application/x-www-form-urlencoded',
    //Authorization: "NTE4Mzg6MTIzNDU2",
  }
})

const color = '#d9001b'
const keynote = 'font-weight: 600; color: #25b864;'
const qrdiv = 'display: flex; justify-content: center;'
const qrbox = `
                width: 300px;
                text-align: center;
                display: inline-block;
                margin: 0 30px;
              `
const qrp = `
              font-size: 20px;
              font-weight: 600;
              color: #aaaaaa;
            `
const qrimg = `
              width: 150px;
              height: 150px;
              margin: 20px auto;
              `
const margin = 'margin-top: 10px;'
let messageBoxShow = false
axios.defaults.retry = 0  // 重试次数，
axios.defaults._retryCount = 0  // 默认不重试,同时用此属性标记该请求是否为一个重试请求
axios.defaults.timeout = 5000 // 默认超时时
//instance.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
// instance.defaults.headers.post["Content-Type"] = "application/json";
// instance.defaults.headers.get['Content-Type'] = 'application/json';
// // 添加请求拦截器
function initAxios() {
  // 添加请求拦截器
  instance.interceptors.request.use(
    config => {
      if (config.method === 'post' && (config.headers['Content-Type'] === 'application/x-www-form-urlencoded')) {
        config.data = qs.stringify(config.data) // 转为formdata数据格式
      }
      if (store.state.token) {
        config.headers.Authorization = store.state.token;
      }
      return config
    },
    error => Promise.error(error)
  )


  // 添加响应拦截器
  instance.interceptors.response.use(
    response => {
      return response
    },
    error => {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            // 这里写清除token的代码
            store.dispatch("cleanUser");
            router.replace({
              path: '/login',
              query: { redirect: router.currentRoute.fullPath }//登录成功后跳入浏览的当前页面
            })
        }
      } else if (error.code === 'ECONNABORTED') {
        if (!messageBoxShow && axios.defaults.retry >= 3) {
          let options = {
            message: `
            <div style="height: 600px;overflow-y: auto">
              <div style="${margin}">
                <p>亲爱的用户:</p>
              </div>
              <div style="${margin}">
                <p>您的网络有问题，请检查一下您网络是否正常！</p>
                <p>解决方法：</p>
                <p style="color: ${color}">中国大陆地区用户:</p>
                <p>(1)可能是校园网禁止访问我们的网站.</p>
                <p>(2)国内访问请<span style="${keynote}">不要挂"梯子"</span>.</p>
                <p>(3)可以用手机做一个热点测试看是否正常.</p>
              </div>
              <div style="${margin}">
                <p style="color: ${color}">中国大陆地区之外用户:</p>
                <p>(1)可能是校园网禁止访问我们的网站。(美国.加拿大.澳洲.新加坡.日本等)</p>
                <p>(2)这一些国家地区<span style="${keynote}">请挂"梯子"</span>.选择香港地区试试</p>
                <p>(3)可以用手机做一个热点测试看是否正常。</p>
                </div>
              <div style="${margin}">
                <p>如果还是有问题：请联系技术支持微信: ace998877abc</p>
              </div>
              <div style="${margin}">
                <p>Dear User:</p>
              </div>
              <div style="${margin}">
                <p>There is something wrong with your network, please check if your network is normal!</p>
                <p>Solution:</p>
                <p style="color: ${color}">Users in Mainland China.</p>
                <p>(1) Campus network may be prohibited to access our website.</p>
                <p>(2) Domestic access please do not open ‘VPN’.</p>
                <p>(3) You can use your mobile phone to do a hotspot test to see if it is normal.</p>
              </div>
              <div style="${margin}">
                <p style="color: ${color}">Users outside mainland China.</p>
                <p>(1) Campus network may be prohibited to access our website. (USA. Canada. Australia. Singapore. Japan, etc.)</p>
                <p>(2) Please use VPN for these countries. Select Hong Kong to try.</p>
                <p>(3) You can use your mobile phone to do a hotspot test to see if it is normal.</p>
              </div>
              <div style="${margin}">
                <p>If there is still a problem: please contact technical support wechat: ace998877abc</p>
              </div>
              <div style="${margin}">
                <div style="${qrdiv}">
                  <div style="${qrbox}">
                    <p style="${qrp}">微信技术支持</p>
                    <p style="${qrp}">WeChat Technical Support</p>
                    <img style="${qrimg}" src="${customerService}" alt="" />
                  </div>
                  <div style="${qrbox}">
                    <p style="${qrp}">whatsApp技术支持</p>
                    <p style="${qrp}">whatsApp Technical Support</p>
                    <img style="${qrimg}" src="${whatApp}" alt="" />
                  </div>
                </div>
              </div>
            </div>
            `,
            type: 'info',
            iconClass: 'none',
            duration: 988888898988,
            dangerouslyUseHTMLString: true,
            showConfirmButton: true,
            confirmButtonText: '明白',
            customClass: 'messageBox',
            callback: dialogClose()
          }
          MessageBox(options)
          messageBoxShow = true
        }
      }
      return Promise.reject(error)
    }
  )
}

function dialogClose() {
  return function () {
    messageBoxShow = false
  }
}

initAxios()

function retry(resolve, reject, method, retryAttempt = 0) {
  method().then(
    res => {
      // 请求成功
      resolve(res);
    }
  ).catch(err => {
    // 请求失败，重试3次
    if (retryAttempt < 3 && err.code === 'ECONNABORTED') {
      setTimeout(() => {
        retry(resolve, reject, method, ++axios.defaults.retry);
      }, 1500);
    } else {
      reject(err);
    }
  });
}

function get(url, options = {}) {
  axios.defaults.retry = 0
  return new Promise((resolve, reject) => {
    retry(resolve, reject, () => {
      return instance.get(url, options);
    }, axios.defaults.retry)
  })
}

function post(url, body = {}, options = {}) {
  axios.defaults.retry = 0
  return new Promise((resolve, reject) => {
    retry(resolve, reject, () => {
      return instance.post(url, body, options);
    }, axios.defaults.retry)
  })
}

export default {
  get,
  post,
};





// WEBPACK FOOTER //
// ./src/api/index.js